import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { IApplicationState } from "redux/root-reducer";
import { isLandlordTypeGuard, ITenantInfo } from "common/models/userInfo";
import { Role } from "auth/types";

export const AddEmailPrompt: React.FC = () => {
  const { t } = useTranslation();
  const history = useHistory();

  const { userIsReady, hasEmail, isTenant, domainCode } = useSelector(
    (state: IApplicationState) => {
      const userInfo = state.common.currentUserInfo;
      const isLandlord = isLandlordTypeGuard(userInfo);
      return {
        userIsReady: state.common.userIsReady,
        hasEmail: isLandlord ? false : !!(userInfo as ITenantInfo).Email,
        isTenant: state.auth.currentUser?.role === Role.Tenant,
        domainCode: state.common.selectedDomain?.Code,
      };
    }
  );

  const isFreshLogin = sessionStorage.getItem("freshLogin") === "true";
  const alreadyDismissed = sessionStorage.getItem("emailPromptDismissed") === "true";
  const [dismissed, setDismissed] = useState(alreadyDismissed);

  if (!userIsReady || !isTenant || hasEmail || dismissed || !isFreshLogin) {
    return null;
  }

  const handleDismiss = () => {
    sessionStorage.setItem("emailPromptDismissed", "true");
    setDismissed(true);
  };

  const handleGoToAccount = () => {
    sessionStorage.setItem("emailPromptDismissed", "true");
    setDismissed(true);
    history.push(`/${domainCode}/profile`);
  };

  return (
    <Dialog open>
      <DialogContent>
        <DialogTitle>{t("Add email address")}</DialogTitle>
        <DialogContentText color="primary">
          {t(
            "You have not added an email address to your account. Go to your account page to add one."
          )}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleDismiss} color="secondary" variant="text">
          {t("Not now")}
        </Button>
        <Button
          onClick={handleGoToAccount}
          color="primary"
          variant="contained"
        >
          {t("Go to account")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
